import 'css-chunksrc/client/scenes/discussionRemoval/styles.scss';export default {
  "discussionRemoval": "_discussionRemoval_1dues_1",
  "header": "_header_1dues_5",
  "group": "_group_1dues_9",
  "subTitle": "_subTitle_1dues_13",
  "text": "_text_1dues_19",
  "main": "_main_1dues_25",
  "buttons": "_buttons_1dues_32"
};